import { BaseError } from './base';

export class NoAddressFoundError extends BaseError {
  constructor() {
    super({
      cause: null,
      code: 'no_address_found_error',
      docsUrl: null,
      name: 'NoAddressFoundError',
      shortMessage: 'No address is connected to the wallet',
    });
  }
}
